import { Routes } from '@angular/router';

import { logsRoutes } from '../logs/logs.routes';
import { usersRoutes } from '../users/users.routes';
import { itemsRoutes } from '../items/items.routes';
import { devicesRoutes } from '../devices/devices.routes';
import { reportsRoutes } from '../reports/reports.routes';
import { settingsRoutes } from '../settings/settings.routes';
import { baseJobsRoutes } from '../base-jobs/base-jobs.routes';
import { warehousesRoutes } from '../warehouses/warehouses.routes';
import { requisitionsRoutes } from '../requisitions/requisitions.routes';
import { kioskAuthGuard } from '../../core/guards/kiosk-auth.guard';
import { kioskDeviceGuard } from '../../core/guards/kiosk-device.guard';
import { jonasExportFilesRoutes } from '../jonas-export-files/jonas-export-files.routes';
import { MainLayoutComponent } from '../../shared/layouts/main/main-layout.component';
import { KioskSignInPageComponent } from '../auth/pages/kiosk-sign-in-page/kiosk-sign-in-page.component';

export const kioskRoutes: Routes = [
	{
		path: 'kiosk',
		children: [
			{
				path: 'auth',
				canActivate: [kioskDeviceGuard],
				children: [
					{
						path: 'sign-in',
						component: KioskSignInPageComponent
					},
					{
						path: '',
						redirectTo: 'sign-in',
						pathMatch: 'full'
					}
				]
			},
			{
				path: '',
				component: MainLayoutComponent,
				canActivate: [kioskDeviceGuard, kioskAuthGuard],
				children: [
					{ path: '', pathMatch: 'full', redirectTo: 'requisitions' },
					...usersRoutes,
					...devicesRoutes,
					...itemsRoutes,
					...requisitionsRoutes,
					...reportsRoutes,
					...logsRoutes,
					...settingsRoutes,
					...warehousesRoutes,
					...baseJobsRoutes,
					...jonasExportFilesRoutes
				]
			}
		]
	}
];
